import React, { useState } from 'react';
import { placeholder } from '../../data/products';
import { apiRequest } from '../../services/api';
import './NewsletterSection.css';

const NewsletterSection: React.FC = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    setError('');

    try {
      await apiRequest('/api/newsletter', {
        method: 'POST',
        body: JSON.stringify({ email }),
      });
      setSubmitted(true);
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="newsletter-section" aria-label="Newsletter signup">
      <div className="newsletter-section__inner container">
        <div className="newsletter-section__decoration" aria-hidden="true">
          <img
            src={placeholder(80, 120, '', '#D8CFC4', '#B78D7A')}
            alt=""
            width={80}
            height={120}
            className="newsletter-section__floral"
          />
        </div>

        <div className="newsletter-section__content">
          <p className="newsletter-section__eyebrow">Be the first to know</p>
          <h2 className="newsletter-section__heading">Stay Connected.</h2>
          <p className="newsletter-section__sub">
            New releases, events, and studio notes.
          </p>

          {submitted ? (
            <p className="newsletter-section__thanks">
              Thank you for joining. Something beautiful is coming your way.
            </p>
          ) : (
            <form className="newsletter-section__form" onSubmit={handleSubmit}>
              <label htmlFor="newsletter-email" className="sr-only">
                Email address
              </label>
              <div className="newsletter-section__form-row">
                <input
                  id="newsletter-email"
                  type="email"
                  className="newsletter-section__input"
                  placeholder="Email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={loading}
                />
                <button type="submit" className="newsletter-section__btn" disabled={loading}>
                  {loading ? '...' : 'Join'}
                </button>
              </div>
              {error && <p className="newsletter-section__error">{error}</p>}
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default NewsletterSection;
